export default __webpack_public_path__ + "static/media/ISEO CLASS-9 EXAM PATTERN 2025.f2ef2467.pdf";